$(document).ready(function() {
	// #### page : component FAQ
	if(!document.querySelector('.faq-accordion')) return false;
	
	var $obj = $('.faq-accordion');
	var $obj_header = $obj.find('.card-header');
	var $obj_body = $obj.find('.card-body');

	// accordion
	var accordion = function(){
		$obj_header.on('click', 'a', function(e){
			e.preventDefault();
			if( $('.GPC0040').hasClass('browseMobile') ){
				$(this).parent().next('.card-body').collapse('toggle');
				$(this).parent().toggleClass('active');
			} else {
				return false;
			}
		});
	};

	// browser size check
	var funcBrowseSize = function(e){
		if (e.matches) {
			$obj_header.removeClass('active');
			/* LGEIS-235 : 20201109 add */
			$obj_header.children('.question').wrap( '<a href="#" role="button"></a>' );
			/*// LGEIS-235 : 20201109 add */
			$obj_body.removeClass('show');
			$('.GPC0040').addClass('browseMobile');
		} else {
			$obj_header.addClass('active');
			$obj_body.addClass('show');
			$('.GPC0040').removeClass('browseMobile');
		}
	};

	mql.maxSm.addListener(funcBrowseSize);
	funcBrowseSize(mql.maxSm);
	
	accordion();
});